module.exports = __webpack_public_path__ + "static/media/PPT.d57871cf.svg";